/**
 * @author Peter
 * @email [hoangvanlam9988@gmail.com]
 * @create date 2021-07-19 09:56:23
 * @modify date 2021-07-19 09:56:23
 * @desc [description]
 */

export const GETME: any = "ART_GET_ME"; // user info
export const AVATAR: any = "AVATAR";
export const TOKEN: any = "TOKEN";
export const LANG: string = "LANG";
export const BACK_URL_LOGIN_SNS: string = "BACK_URL_LOGIN_SNS";

export const BLOCK_IP = "BLOCK_IP";
export const TEMP_EVENT_2025 = "TEMP_EVENT_2025"; // event2025 임시 플래그
